import { CommonModule } from '@angular/common';
import { Component, OnInit} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavController, NavParams, ModalController, IonicModule } from '@ionic/angular';
import { ImagePipe } from 'src/app/pipes/image/image';
import { QRCodeModule } from 'angularx-qrcode';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-qr-code',
  templateUrl: './qr-code.page.html',
  styleUrls: ['./qr-code.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    QRCodeModule,
  ],
})
export class QrCodePage implements OnInit {
  public qrCode: string = '';
  nome: any;
  foto: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController
  ) {
    this.nome = navParams.get('nome');
    this.foto = navParams.get('foto');

    this.qrCode =
      JSON.stringify({
        'C': navParams.get('idPessoa'),
        'N': navParams.get('nome'),
        'I': navParams.get('idInstituicao'),
      });
  }

  ngOnInit() { }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

}
